import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container" }

import LeftMenu from "@/components/com/LeftMenu"
	import Nav from "@/components/com/Nav"
	import Bread from "@/components/com/Bread"
	import Content from "@/components/com/Content"
	import { useStore } from 'vuex'
	
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

	const {dispatch} = useStore()
	
	dispatch('publicOptions/getplatformInfo', 'needload')
	dispatch('publicOptions/getPersonInfo')
	// dispatch('publicOptions/getMenuList')
	
	const showBeian = location.origin.indexOf('www.xkgaoneng.cn') > -1

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "body-container" }, {
    default: _withCtx(() => [
      (_ctx.$route.meta.showLeftMenu)
        ? (_openBlock(), _createBlock(_unref(LeftMenu), { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_container, { class: "main-container flex-item" }, {
        default: _withCtx(() => [
          (_ctx.$route.meta.showNav)
            ? (_openBlock(), _createBlock(_component_el_header, {
                key: 0,
                class: _normalizeClass({bread: _ctx.$route.meta.showBread})
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Nav)),
                  (_ctx.$route.meta.showBread)
                    ? (_openBlock(), _createBlock(_unref(Bread), { key: 0 }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_main, {
            class: _normalizeClass(["body-main", {pad0: !_ctx.$route.meta.showLeftMenu && !_ctx.$route.meta.showNav}])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(Content))
              ])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_footer, {
            class: "main-footer center",
            height: "30px"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("a", {
                href: "https://beian.mps.gov.cn/#/query/websearch?code=35021202000966",
                rel: "noreferrer",
                target: "_blank"
              }, "闽公网安备 35021202000966号", -1),
              _createTextVNode(" / "),
              _createElementVNode("a", {
                href: "https://beian.miit.gov.cn/",
                target: "_blank"
              }, "备案号：闽ICP备18021136号-2", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})